module.exports = __webpack_public_path__ + "img/arrow-down.d6652b2b.svg";